
import { defineComponent } from 'vue';
import { InvoiceType } from '@/models/Enums';
import Invoice from '@/components/BusinessClients/BusinessDocuments/Invoice.vue';

export default defineComponent({
    props: {
        clientId: {
            type: Number,
            required: true
        }
    },
    components: {
        Invoice
    },
    async setup() {
        const invoiceType = InvoiceType;
        return { invoiceType };
    }
});
